import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { flatten } from 'lodash';
import { DateTime } from 'luxon';
import { dateUtils } from 'utils';

export default (providerAccountId, healthcareServiceId, locationId, dateTime, timezone) => {
  const startDateTime = dateTime ? dateTime.setZone('UTC').minus({ days: 1 }).toUTC().toString('t') : null;
  const endDateTime = dateTime ? dateTime.setZone('UTC').plus({ months: 1, days: 2 }).toUTC().toString('t') : null;

  const { data, isLoading, isSuccess } = useQuery(
    ['GET', `/apis/v2/patient/bookings/provider_availabilities`, { providerAccountId, healthcareServiceId, locationId, startDateTime, endDateTime }],
    {
      enabled: !!(providerAccountId && healthcareServiceId && locationId && startDateTime),
      refetchOnMount: 'always',
    },
  );

  const options = useMemo(
    () =>
      timezone !== ''
        ? flatten(data?.data.attributes.availabilities.map((x) => x.timeslots) || []).map((x) => ({
            id: `${DateTime.fromISO(x.start).setZone(timezone).toFormat('t')} - ${DateTime.fromISO(x.end).setZone(timezone).toFormat('t')}`,
            label: dateUtils.formatTimeString(x.start),
            value: x.start,
            data: x,
          }))
        : [],
    [data, timezone],
  );
  //
  const availableDays = useMemo(
    () => (timezone !== '' ? flatten(data?.data.attributes.availabilities.map((x) => x.timeslots) || []).map((x) => DateTime.fromISO(x.start).setZone('UTC')) : []),
    [data, timezone],
  );
  return { data: options || [], availableDays, isLoading, isFetching: isLoading, isSuccess };
};
